"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellRendererAdapter = void 0;
require("react");
require("@veeam/components");
require("@veeam/components/lib/Grid/types");
require("../types");
const cellRendererAdapter = (key, cellRenderer, readOnlyGetter) => {
    return (rowData, payload) => {
        return cellRenderer(Object.assign(Object.assign({}, payload), { cellData: rowData[key], isReadOnly: readOnlyGetter === null || readOnlyGetter === void 0 ? void 0 : readOnlyGetter(rowData) }));
    };
};
exports.cellRendererAdapter = cellRendererAdapter;
//# sourceMappingURL=cellRendererAdapter.js.map